import React, { useEffect } from 'react';
import useTheme from "@mui/material/styles/useTheme";
import useMediaQuery from '@mui/material/useMediaQuery'
import { useSxStyles } from '../styles/sxStyles';
import { useCurrentUser } from '../context/contextHooks';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Grid2 from "@mui/material/Grid2";
import {getCurrency} from "../config/utils";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Select from '@mui/material/Select'
import {PatternFormat} from "react-number-format";
import PaymentLocation from "./PaymentLocation";

const PosData = (props) => {
    const terminals = props.terminals;
    const paymentRequest = props.paymentRequest;
    const paymentFields = props.paymentFields;
    const setPaymentFields = props.setPaymentFields;
    const court = props.court
    const locations = props.locations;
    const user = props.user;
    const setLocation = props.setLocation;
    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const classes = useSxStyles;
    const [currentUser,] = useCurrentUser();

    const handleName = (e) => {
        const val = e.target.value;
        if (val && val !== paymentRequest.payorName) {
            setPaymentFields({...paymentFields, payorName: val});
        }
    }

    const handleTerminal = (e) => {
        const val = e.target.value;
        if (val && val !== paymentRequest.laneId) {
            setPaymentFields({...paymentFields, laneId: val});
        }
    }

    const handleManualEntry = (e) => {
        const val = e.target.checked;
        setPaymentFields({...paymentFields, manualEntry: val});
    }

    const handleEmail = (e) => {
        const val = e.target.value;
        if (val && val !== paymentRequest.email) {
            setPaymentFields({...paymentFields, email: val});
        }
    }

    const handlePhone = (values) => {
        if (values && values.value && values.value.length === 10) {
            const val = values.formattedValue;
            if (val !== paymentRequest.phone) {
                setPaymentFields({...paymentFields, phone: val});
            }
        }
    }

    const handleZip = (values) => {
        if (values && values.value && values.value.length === 5) {
            const val = values.value;
            if (val !== paymentRequest.billingZip) {
                setPaymentFields({...paymentFields, billingZip: val});
            }
        }
    }

    useEffect(() => {
        if (currentUser && currentUser.defaultTerminal && paymentFields && !paymentFields.laneId) {
            setPaymentFields({...paymentFields, laneId: currentUser.defaultTerminal});
        }
    }, [currentUser, paymentFields])

    return (<>
        <Paper variant='body1' elevation={3} sx={classes.controlPanel}>
            <Grid2 container spacing={1}>
                <Grid2
                    sx={{paddingLeft: '0', paddingTop: '1rem'}}
                    size={{
                        xs: 12,
                        sm: 6
                    }}>
                    <Typography component='span' variant='subtitle1' color='primary' sx={{fontSize: '1.2rem'}}>
                        Amount:
                    </Typography>
                    <Typography component='span' variant='subtitle2' color='textPrimary' sx={{fontSize: '1.2rem', marginLeft: '1rem'}}>
                        {getCurrency(paymentRequest.totalAmount)}
                    </Typography>
                </Grid2>
                <Grid2
                    sx={{paddingLeft: '0'}}
                    size={{
                        xs: 12,
                        sm: 6
                    }}>
                    <FormControl fullWidth sx={[smallScreen ? {
                        marginLeft: '0'
                    } : {
                        marginLeft: '.5rem'
                    }]}>
                        <FormLabel shrink={true} sx={{...classes.inputLabel, paddingTop: '0', marginTop: '0'}}>
                            Name on Account
                        </FormLabel>
                        <TextField
                            name='name'
                            variant='outlined'
                            fullWidth
                            defaultValue={paymentRequest.payorName}
                            onBlur={handleName}
                            slotProps={{
                                htmlInput: {sx: classes.textbox}
                            }}
                        />
                    </FormControl>
                </Grid2>
                <Grid2
                    sx={{paddingLeft: '0'}}
                    size={{
                        xs: 12,
                        sm: 6
                    }}>
                    <FormControl
                        name='terminal'
                        component="fieldset"
                        fullWidth
                    >
                        <FormLabel shrink sx={{...classes.inputLabel, paddingTop: '0', marginTop: '0'}}>
                            Terminal
                        </FormLabel>
                        <Select
                            name='terminal'
                            native
                            variant='outlined'
                            fullWidth
                            defaultValue={currentUser.defaultTerminal ? currentUser.defaultTerminal : 0}
                            onChange={handleTerminal}
                            sx={{...classes.select, ...classes.smallText}}
                        >
                            <option key='0' value=''>None</option>
                            {terminals && terminals.length > 0 && terminals.map((term) => {
                                return (
                                    <option key={`${term.laneId}`} value={term.laneId}>{term.terminalId}</option>
                                );
                            })}
                        </Select>
                    </FormControl>
                </Grid2>
                <Grid2
                    sx={{paddingLeft: '0'}}
                    size={{
                        xs: 12,
                        sm: 6
                    }}>
                    <FormControl
                        name='manualEntry'
                        component="fieldset"
                        sx={{paddingLeft: '.5rem'}}
                    >
                        <FormLabel shrink={true} sx={classes.inputLabel}>
                            Manual Entry
                        </FormLabel>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    name="manualEntry"
                                    color='primary'
                                    defaultChecked={false}
                                    onChange={handleManualEntry}
                                    sx={{paddingTop: '.3rem'}}
                                />
                            }
                            label=''
                        />
                    </FormControl>
                </Grid2>
                <Grid2
                    sx={{paddingLeft: '0'}}
                    size={{
                        xs: 12,
                        sm: 6
                    }}>
                    <FormControl fullWidth>
                        <FormLabel shrink={true} sx={classes.inputLabel}>Email Address</FormLabel>
                        <TextField
                            name='email'
                            variant='outlined'
                            fullWidth
                            defaultValue={paymentRequest.email}
                            onBlur={handleEmail}
                            slotProps={{
                                htmlInput: {sx: classes.textbox}
                            }}
                        />
                    </FormControl>
                </Grid2>
                <Grid2
                    sx={{paddingLeft: '0'}}
                    size={{
                        xs: 12,
                        sm: 6
                    }}>
                    <FormControl fullWidth sx={[smallScreen ? {
                        marginLeft: '0'
                    } : {
                        marginLeft: '.5rem'
                    }]}>
                        <FormLabel shrink={true} sx={classes.inputLabel}>Phone Number</FormLabel>
                        <PatternFormat
                            name='phone'
                            customInput={TextField}
                            type='text'
                            autoComplete='off'
                            variant='outlined'
                            format="(###) ###-####"
                            InputProps={{
                                sx: {...classes.numberbox}
                            }}
                            defaultValue={paymentRequest.phone}
                            onValueChange={(values) => handlePhone(values)}
                        />
                    </FormControl>
                </Grid2>
                { court.requireZip &&
                    <Grid2
                        sx={{paddingLeft: '0', marginTop: '.5rem'}}
                        size={{
                            xs: 12,
                            sm: 6
                        }}>
                        <FormControl fullWidth>
                            <FormLabel htmlFor='billigZip' shrink={true} sx={classes.inputLabel} >Billing Zip</FormLabel>
                            <PatternFormat
                                id='billingZip'
                                name='billingZip'
                                customInput={TextField}
                                type='text'
                                autoComplete='off'
                                variant='outlined'
                                format='#####'
                                InputProps={{
                                    sx: {...classes.numberbox}
                                }}
                                defaultValue={paymentRequest.billingZip}
                                onValueChange={(values) => handleZip(values)}
                            />
                        </FormControl>
                    </Grid2>
                }
                { locations && locations.length > 0 &&
                    <Grid2
                        sx={{marginTop: '.5rem', paddingLeft: '0'}}
                        size={{
                            xs: 12,
                            sm: 6
                        }}>
                        <PaymentLocation locations={locations} user={user} setLocation={setLocation} offset={!smallScreen && court.requireZip} />
                    </Grid2>
                }
            </Grid2>
        </Paper>
    </>);
}

export default PosData;
